import * as React from "react";
const SvgSecurityUpdateWarning = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.01 1v22H19V1H5.01zM17 18H7V6h10v12z",
  fill: "currentColor"
}));
export default SvgSecurityUpdateWarning;